export default __webpack_public_path__ + "static/Get_Connected_Full_Color-e81f1a22d3a5a66c0bcbb4e0b9f40e7a.png";